export const isValidRedirectUrl = (url: string): boolean => {
  try {
    // Handle null/undefined/empty inputs
    if (!url || typeof url !== 'string' || url.trim() === '') {
      return false;
    }

    // Reject URLs with unencoded spaces (malformed)
    if (url.includes(' ')) {
      return false;
    }

    // Reject URLs with control characters (tab, newline, carriage return)
    if (/[\t\n\r]/.test(url)) {
      return false;
    }

    // Decode the URL to prevent encoded bypass attacks
    // Use decodeURIComponent to decode %2F -> / and other encoded characters
    const decodedUrl = decodeURIComponent(url);

    // Reject URLs with backslashes (potential protocol confusion)
    if (decodedUrl.includes('\\')) {
      return false;
    }

    // Reject URLs with full-width solidus (Unicode bypass attempt)
    if (decodedUrl.includes('\uFF0F')) {
      return false;
    }

    // Reject URLs that start with // (protocol-relative URLs)
    if (decodedUrl.startsWith('//')) {
      return false;
    }

    // Reject URLs with @ symbol (credential injection)
    if (decodedUrl.includes('@')) {
      return false;
    }

    // Accept relative paths that start with single /
    // But reject paths that become // after normalization (e.g., ///path)
    if (decodedUrl.startsWith('/')) {
      // Normalize multiple slashes to single slash
      const normalized = decodedUrl.replace(/\/+/g, '/');
      // After normalization, it should still start with single /
      if (normalized.startsWith('//')) {
        return false;
      }

      // Reject relative paths that start with /javascript: (XSS vector)
      const lowerNormalized = normalized.toLowerCase();
      if (lowerNormalized.startsWith('/javascript:')) {
        return false;
      }

      return true;
    }

    // Check if it's an absolute URL with a protocol
    if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(decodedUrl)) {
      // Validate it's same-origin
      try {
        const urlObj = new URL(decodedUrl);
        return urlObj.origin === window.location.origin;
      } catch {
        // Invalid URL format (e.g., 'ht!tp://example.com')
        return false;
      }
    }
    return false;
  } catch {
    return false;
  }
};
